export default __webpack_public_path__ + "static/popup-back-c169311940be37d131b2ce3ee323e74a.webp";